import React from "react";

/**
 * TKL butterfly mark used for loading states (animated via .tkl-spinner-logoLoader).
 * Use size for inline/button spinners; default matches full-page LogoLoader.
 */
const ButterflyMark = React.memo(function ButterflyMark({
  size = 80,
  className = "",
  style,
  ...rest
}) {
  const dim = typeof size === "number" ? `${size}px` : size;
  return (
    <div
      className={`tkl-spinner-logoLoader ${className}`.trim()}
      style={style}
      role="status"
      aria-label="Loading"
      {...rest}
    >
      <svg
        version="1.2"
        baseProfile="tiny"
        xmlns="http://www.w3.org/2000/svg"
        x="10px"
        y="10px"
        viewBox="0 0 202 202"
        style={{ width: dim, height: dim, overflow: "visible" }}
      >
        <path
          fill="#1DBAAD"
          id="green"
          d="M92,92H22C9.9,92,0,82.1,0,70L0,0l24,0c37.4,0,68,30.6,68,68V92z"
        />
        <path
          fill="#FCB127"
          id="yellow"
          d="M180,92h-70V68c0-37.6,30.4-68,68-68h24v70C202,82.2,192.2,92,180,92z"
        />
        <path
          fill="#DF1C45"
          id="red"
          d="M47,202h-2c-24.8,0-45-20.3-45-45v-2c0-24.9,20.1-45,45-45h47v47C92,181.9,71.9,202,47,202z"
        />
        <path
          fill="#3F749C"
          id="blue"
          d="M157,202h-2c-24.8,0-45-20.3-45-45v-47h47c24.9,0,45,20.1,45,45v2C202,181.9,181.9,202,157,202z"
        />
      </svg>
    </div>
  );
});

export default ButterflyMark;
